import { render, staticRenderFns } from "./cardVirtualConversationDelete.vue?vue&type=template&id=05080ea6"
import script from "./cardVirtualConversationDelete.vue?vue&type=script&lang=js"
export * from "./cardVirtualConversationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports